import cx from 'classnames'
import { Tooltip as ReactTooltip } from 'react-tooltip'

import Icon from '../Icon/Icon'

import './Tooltip.scss'

const Tooltip = ({
    id,
    content,
    placement,
    clickable = false,
    controlled = false,
    isOpen = false,
    className,
    onClick,
}) => {
    const events = clickable ? ['click'] : ['hover']

    return (
        <div className={cx('tooltip-wrapper', className)}>
            <div id={id} role={'button'} onClick={onClick}>
                <Icon name={'info-lightblue'} />
            </div>
            {controlled ? (
                <ReactTooltip
                    anchorId={id}
                    place={placement}
                    content={content}
                    events={events}
                    noArrow
                    isOpen={isOpen}
                    className={'tooltip-wrapper--window'}
                />
            ) : (
                <ReactTooltip
                    anchorId={id}
                    place={placement}
                    content={content}
                    events={events}
                    noArrow
                    className={'tooltip-wrapper--window'}
                />
            )}
        </div>
    )
}

export default Tooltip
